import axios from "axios";
import router from "./Router";

let apiLeitsystemConfig = {
  baseURL: "",
  withCredentials: false,
};

const ApiLeitsystem = axios.create(apiLeitsystemConfig);

ApiLeitsystem.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (!error.response) return;
    if (error.response.status === 401) {
      let startLocation = router["history"]["_startLocation"].split("/")[1];
      if (
        router.currentRoute.name !== "Auswertung" &&
        router.currentRoute.name !== "Offerte" &&
        router.currentRoute.name !== "login" &&
        router.currentRoute.name !== "leitsystem" &&
        router.currentRoute.name !== "newpassword" &&
        startLocation !== "newpassword"
      ) {
        router.push({ name: "login" });
      }
    }

    return Promise.reject(error);
  }
);

export default ApiLeitsystem;
